var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "search-list" },
    [
      _c("div", { staticClass: "search-header" }, [
        _c("div", { staticClass: "header-content" }, [
          _c("div", { staticClass: "logo", on: { click: _vm.toIndex } }),
          _vm._v(" "),
          _c("div", { staticClass: "search-box" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword"
                }
              ],
              staticClass: "search-inp",
              attrs: { placeholder: "请输入关键词" },
              domProps: { value: _vm.keyword },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.keyword = $event.target.value
                }
              }
            }),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "search-btn", on: { click: _vm.query } },
              [_vm._v("搜索")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content" }, [
        _c("div", { staticClass: "content-left" }, [
          _vm.showLoading
            ? _c(
                "div",
                { staticClass: "article-list loading" },
                [_c("loading", { attrs: { width: _vm.loadingWidth } })],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.articles.length > 0 && !_vm.showLoading
            ? _c(
                "div",
                { staticClass: "article-list" },
                _vm._l(_vm.articles, function(item, index) {
                  return _c(
                    "div",
                    { key: index, staticClass: "article-item" },
                    [
                      _c("div", { staticClass: "item-content" }, [
                        item.attachment
                          ? _c(
                              "div",
                              {
                                staticClass: "item-img",
                                on: {
                                  click: function($event) {
                                    _vm.jumpToDetail(item.url)
                                  }
                                }
                              },
                              [_c("img", { attrs: { src: item.attachment } })]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            class: item.attachment
                              ? "item-desc"
                              : "item-desc-noImg"
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "desc-title",
                                on: {
                                  click: function($event) {
                                    _vm.jumpToDetail(item.url)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(item.title))]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-content" }, [
                              _vm._v(_vm._s(item.content))
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "desc-skip" }, [
                              _c(
                                "span",
                                {
                                  staticClass: "skip-address",
                                  on: {
                                    click: function($event) {
                                      _vm.jumpToDetail(item.url)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(item.url))]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "skip-date" }, [
                                _vm._v(_vm._s(item.publishTime))
                              ])
                            ])
                          ]
                        )
                      ])
                    ]
                  )
                })
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.articles.length === 0 && !_vm.showLoading
            ? _c(
                "div",
                { staticClass: "article-list no-data" },
                [
                  _c("no-data", {
                    attrs: {
                      title: _vm.noDataTitle,
                      "img-style": _vm.noDataStyle
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.pageTotal > 0
            ? _c(
                "div",
                { staticClass: "select-page" },
                [
                  _c("pagination", {
                    attrs: { pageIndex: _vm.pageNum, totalNum: _vm.pageTotal },
                    on: { changeItem: _vm.changePage }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "content-right" },
          [
            _vm._l(_vm.rightAds, function(item, index) {
              return _vm.rightAds.length > 0
                ? _c(
                    "div",
                    { key: index, staticClass: "ad-right-item" },
                    [
                      _c("advertisement", {
                        attrs: { "img-url": item.thumb, "ad-url": item.adsUrl }
                      })
                    ],
                    1
                  )
                : _vm._e()
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "currency-list",
                class: _vm.rightAds.length > 0 ? "m-top" : ""
              },
              [_c("quotation", { attrs: { "more-url": _vm.moreCurrencyUrl } })],
              1
            )
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c("ui-footer")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-11203436", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11203436","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/information/view/searchList/SearchList.vue
// module id = 617
// module chunks = 1